import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

export default function Contatti() {
  return (
    <div>
      <SEO
        title="Contatti"
        description="Contatta Smart News Italia: richieste editoriali, diritti sui contenuti di terzi, questioni sulla privacy e sui dati personali, o segnalazioni di errori nelle traduzioni."
      />
      <PageHero
        crumb="Contatti"
        overline="Contatti"
        title="Contatti"
        subtitle="Scrivici per richieste generali, diritti sui contenuti o questioni relative ai dati personali."
        icon={Mail}
      />
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-12 space-y-6 text-sm leading-relaxed text-muted-foreground">
        <p>
          Smart News Italia raccoglie discorsi e dichiarazioni ufficiali dei leader mondiali e li rende
          disponibili al pubblico italiano con il video originale, il testo integrale a fronte, la traduzione
          in italiano e il collegamento alla fonte ufficiale. Se hai una richiesta, una segnalazione o una
          domanda sul nostro lavoro, di seguito trovi il contatto più adatto: rispondiamo a tutti i messaggi
          pertinenti, di norma entro pochi giorni lavorativi.
        </p>

        <div className="bg-card border border-border rounded-sm p-6 space-y-4">
          <p><strong className="text-foreground">Richieste generali e redazione:</strong><br />
            Domande sul progetto, proposte di collaborazione o richieste dei media.<br />
            <a className="text-primary hover:underline" href="mailto:contatti@smartnewsitalia.it">contatti@smartnewsitalia.it</a></p>
          <p><strong className="text-foreground">Diritti sui contenuti di terzi:</strong><br />
            Segnalazioni relative a diritti d'autore o all'uso di materiali di cui detieni i diritti.<br />
            <a className="text-primary hover:underline" href="mailto:contatti@smartnewsitalia.it">contatti@smartnewsitalia.it</a></p>
          <p><strong className="text-foreground">Privacy e dati personali:</strong><br />
            Esercizio dei diritti previsti dal GDPR (accesso, rettifica, cancellazione, opposizione) e
            domande sul trattamento dei dati.<br />
            <a className="text-primary hover:underline" href="mailto:privacy@smartnewsitalia.it">privacy@smartnewsitalia.it</a></p>
        </div>

        <div className="space-y-3">
          <h2 className="font-serif text-xl font-bold text-foreground">Segnalare un errore in una traduzione</h2>
          <p>
            La fedeltà dei contenuti è la nostra priorità. Se noti un'imprecisione in una traduzione, in un
            sottotitolo o nella trascrizione, puoi usare il pulsante <strong className="text-foreground">"Segnala
            un errore"</strong> presente nella pagina di ciascun discorso: è il modo più rapido perché la
            segnalazione arriva già collegata al contenuto interessato. In alternativa puoi scriverci via email
            indicando il titolo del discorso e il punto preciso da verificare. Ogni segnalazione viene esaminata
            dalla redazione e, se necessario, il contenuto viene corretto.
          </p>
        </div>

        <div className="space-y-3">
          <h2 className="font-serif text-xl font-bold text-foreground">Trasparenza e fonti</h2>
          <p>
            Traduzione, doppiaggio ed eventuale sincronizzazione labiale sono realizzati con strumenti di
            intelligenza artificiale sotto controllo editoriale. Per ogni discorso pubblichiamo la fonte
            ufficiale, così puoi sempre confrontare la nostra versione con l'originale. Se vuoi capire come
            verifichiamo le fonti e come lavoriamo, consulta la pagina{" "}
            <Link to="/metodologia" className="text-primary hover:underline">Metodo e trasparenza</Link>.
            Per sapere come trattiamo i tuoi dati leggi l'{" "}
            <Link to="/privacy-policy" className="text-primary hover:underline">Informativa privacy</Link>.
          </p>
          <p>
            Smart News Italia non è una testata giornalistica registrata: è un progetto editoriale
            indipendente dedicato all'accesso diretto alle parole dei protagonisti dell'attualità
            internazionale, senza commenti né interpretazioni.
          </p>
        </div>
      </div>
    </div>
  );
}
